/**
=========================================================
* Otis Admin PRO - v2.0.1
=========================================================

* Product Page: https://material-ui.com/store/items/otis-admin-pro-material-dashboard-react/
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

// @mui material components
import Link from "@mui/material/Link";
import Icon from "@mui/material/Icon";

// Otis Admin PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Otis Admin PRO React base styles
import typography from "assets/theme/base/typography";
import { useTranslation } from "react-i18next";

function Footer({ company, links }) {
  const { href, name } = company;
  const { size } = typography;
  const { t } = useTranslation();

  const renderLinks = () =>
    links.map((link) => (
      <MDBox fontSize={size.md} key={link.name} component="li" px={2} lineHeight={1}>
        <Link href={link.href} target="_blank">
          <MDTypography fontSize={size.md} variant="button" fontWeight="regular" color="white">
            {t(`footer.${link.name}`)}
          </MDTypography>
        </Link>
      </MDBox>
    ));

  return (
    <MDBox
      width="100%"
      display="flex"
      flexDirection={{ xs: "column", lg: "row" }}
      justifyContent="space-between"
      alignItems="center"
      px={3}
      py={2}
      sx={{
        backgroundColor: "#10b0d5",
        color: "#fff",
        borderTop: "1px solid #dee2e6",
        borderRadius: "8px 8px 8px 8px",
      }}
    >
      <MDBox color= "#fff" display="flex" alignItems="center" flexWrap="wrap" fontSize={size.md}>
        &copy; {new Date().getFullYear()}
        <Link
          href={href}
          target="_blank"
          underline="none"
          sx={{ ml: 0.5, color: "#fff", fontWeight: 500 }}
        >
          {name}
        </Link>
      </MDBox>

      <MDBox
        component="ul"
        sx={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "center",
          justifyContent: "center",
          listStyle: "none",
          color: "#fff" ,
          padding: 0,
          margin: 0,
          mt: { xs: 2, lg: 0 },
        }}
      >
        {links.map((link) => (
          <MDBox key={link.name} component="li" px={1}>
            <Link
              href={link.href}
              target="_blank"
              underline="none"
              sx={{
                color: "#fff" ,
                fontSize: size.md,
                fontWeight: 400,
                "&:hover": {
                  color: "#343a40",
                  textDecoration: "underline",
                },
              }}
            >
              {t(`footer.${link.name}`)}
            </Link>
          </MDBox>
        ))}
      </MDBox>
    </MDBox>
  );
}

// Setting default values for the props of Footer
Footer.defaultProps = {
  company: {
    href: "https://www.maxu.co",
    name: "Sunshine Analytics, LLC.",
  },
  links: [
    {
      href: "https://www.maxu.co",
      name: "aboutUs",
    },
    {
      href: "https://maxu.co/#contact-maxu",
      name: "contactUs",
    },

    {
      href: "/terms_conditions",
      name: "termsConditions",
    },

    {
      href: "/privacy_policy",
      name: "privacyPolicy",
    },
  ],
};

// Typechecking props for the Footer
Footer.propTypes = {
  company: PropTypes.instanceOf(Object),
  links: PropTypes.instanceOf(Array),
};

export default Footer;
